import PageLoader from "kustom-front/src/components/atoms/PageLoader";
import React, {
  createContext,
  FunctionComponent,
  ReactNode,
  useContext,
  useMemo,
  useState,
} from "react";
import { HomeSkeleton } from "@Components/molecules/home/HomeSkeleton";

interface GlobalLoaderContextType {
  loading: boolean;
  setLoading: (loading: boolean) => void;
}

const GlobalLoaderContext = createContext<GlobalLoaderContextType>({} as GlobalLoaderContextType);

export const useGlobalLoader = (): GlobalLoaderContextType => {
  return useContext(GlobalLoaderContext);
};

interface Props {
  children: ReactNode;
  initialLoading: boolean;
  type?: "default" | "home";
}

const WithGlobalLoader: FunctionComponent<Props> = ({
  children,
  initialLoading,
  type = "default",
}) => {
  const [loading, setLoading] = useState<boolean>(initialLoading);

  const value = useMemo(
    () => ({
      loading,
      setLoading,
    }),
    [loading, setLoading]
  );

  return (
    <GlobalLoaderContext.Provider value={value}>
      {type === "home" ? (
        <HomeSkeleton loaded={!loading} />
      ) : (
        <PageLoader fullPage={true} loaded={!loading} />
      )}
      {children}
    </GlobalLoaderContext.Provider>
  );
};

export default WithGlobalLoader;
